<div class="c-cms-form">
    <div class="form-flex">
        <div class="form-label">{{if field.required == 1}}<span class="form-required">*</span>{{/if}}{{field.displayName}}</div>
        <div class="form-value">
            <div class="form-row">
                <div class="c-form-file">
                    {{if !field.value}}
                    <div class="file-upload">
                        <div class="file-area">
                            <div class="file-text">点击添加文件</div>
                            <div class="file-tips">文件大小限制：50M</div>
                        </div>
                        <input type="file" class="file-input" title="" onchange="$sk.changeFILE(this, '{{field.fieldName}}')" accept="{{field.accept}}">
                    </div>
                    {{else}}
                    <div class="file-file">
                        <div class="file-type {{field.fileTypeJson[field.fileType] || 'other'}}">
                            {{field.value ? field.value.fileName : ''}}
                        </div>
                        <div class="file-clear-file" onclick="$sk.clearFILE(this, '{{field.fieldName}}')"></div>
                    </div>
                    {{/if}}
                </div>
            </div>
            {{if field.dirty && field.invalid}}
            <div class="form-row form-error">{{field.validationMessage}}</div>
            {{/if}}
        </div>
    </div>
</div>